/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

import type {
  CountRequestDto,
  CountResponseDto,
  GetAllTrackableTargetsParams,
  GetTargetCountExtendedParams,
  GetTargetCountParams,
  GetTargetsParams,
  MinimalTarget,
  TargetsResponse
} from '../../model';





/**
 * Can be used for getting target count.
 * @summary Get target count in JSON
 */
export const getTargetCountExtended = (
    countRequestDto: CountRequestDto,
    params?: GetTargetCountExtendedParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CountResponseDto>> => {
    
    
    return axios.default.post(
      `/api/v1.1/targets/count/extended`,
      countRequestDto,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getGetTargetCountExtendedMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTargetCountExtended>>, TError,{data: CountRequestDto;params?: GetTargetCountExtendedParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof getTargetCountExtended>>, TError,{data: CountRequestDto;params?: GetTargetCountExtendedParams}, TContext> => {

const mutationKey = ['getTargetCountExtended'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getTargetCountExtended>>, {data: CountRequestDto;params?: GetTargetCountExtendedParams}> = (props) => {
          const {data,params} = props ?? {};

          return  getTargetCountExtended(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetTargetCountExtendedMutationResult = NonNullable<Awaited<ReturnType<typeof getTargetCountExtended>>>
    export type GetTargetCountExtendedMutationBody = CountRequestDto
    export type GetTargetCountExtendedMutationError = AxiosError<unknown>

    /**
 * @summary Get target count in JSON
 */
export const useGetTargetCountExtended = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTargetCountExtended>>, TError,{data: CountRequestDto;params?: GetTargetCountExtendedParams}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getTargetCountExtended>>,
        TError,
        {data: CountRequestDto;params?: GetTargetCountExtendedParams},
        TContext
      > => {

      const mutationOptions = getGetTargetCountExtendedMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Can be used for listing targets.
 * @summary Get targets in JSON
 */
export const getTargets = (
    params: GetTargetsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MinimalTarget[]>> => {
    
    
    return axios.default.get(
      `/api/v1.1/targets`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetTargetsQueryKey = (params?: GetTargetsParams,) => {
    return [
    `/api/v1.1/targets`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetTargetsQueryOptions = <TData = Awaited<ReturnType<typeof getTargets>>, TError = AxiosError<unknown>>(params: GetTargetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargets>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTargetsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTargets>>> = ({ signal }) => getTargets(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTargets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTargetsQueryResult = NonNullable<Awaited<ReturnType<typeof getTargets>>>
export type GetTargetsQueryError = AxiosError<unknown>


export function useGetTargets<TData = Awaited<ReturnType<typeof getTargets>>, TError = AxiosError<unknown>>(
 params: GetTargetsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTargets>>,
          TError,
          Awaited<ReturnType<typeof getTargets>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTargets<TData = Awaited<ReturnType<typeof getTargets>>, TError = AxiosError<unknown>>(
 params: GetTargetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTargets>>,
          TError,
          Awaited<ReturnType<typeof getTargets>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTargets<TData = Awaited<ReturnType<typeof getTargets>>, TError = AxiosError<unknown>>(
 params: GetTargetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargets>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get targets in JSON
 */

export function useGetTargets<TData = Awaited<ReturnType<typeof getTargets>>, TError = AxiosError<unknown>>(
 params: GetTargetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargets>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTargetsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetTargetsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getTargets>>, TError = AxiosError<unknown>>(params: GetTargetsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargets>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTargetsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTargets>>> = ({ signal }) => getTargets(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTargetsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getTargets>>>
export type GetTargetsSuspenseQueryError = AxiosError<unknown>


export function useGetTargetsSuspense<TData = Awaited<ReturnType<typeof getTargets>>, TError = AxiosError<unknown>>(
 params: GetTargetsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargets>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTargetsSuspense<TData = Awaited<ReturnType<typeof getTargets>>, TError = AxiosError<unknown>>(
 params: GetTargetsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargets>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTargetsSuspense<TData = Awaited<ReturnType<typeof getTargets>>, TError = AxiosError<unknown>>(
 params: GetTargetsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargets>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get targets in JSON
 */

export function useGetTargetsSuspense<TData = Awaited<ReturnType<typeof getTargets>>, TError = AxiosError<unknown>>(
 params: GetTargetsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargets>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTargetsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Can be used for getting one target.
 * @summary Get target in JSON
 */
export const getTargetById = (
    targetId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    
    
    return axios.default.get(
      `/api/v1.1/targets/${targetId}`,options
    );
  }




export const getGetTargetByIdQueryKey = (targetId?: number,) => {
    return [
    `/api/v1.1/targets/${targetId}`
    ] as const;
    }

    
export const getGetTargetByIdQueryOptions = <TData = Awaited<ReturnType<typeof getTargetById>>, TError = AxiosError<MinimalTarget>>(targetId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargetById>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTargetByIdQueryKey(targetId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTargetById>>> = ({ signal }) => getTargetById(targetId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(targetId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTargetById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTargetByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getTargetById>>>
export type GetTargetByIdQueryError = AxiosError<MinimalTarget>


export function useGetTargetById<TData = Awaited<ReturnType<typeof getTargetById>>, TError = AxiosError<MinimalTarget>>(
 targetId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargetById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTargetById>>,
          TError,
          Awaited<ReturnType<typeof getTargetById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTargetById<TData = Awaited<ReturnType<typeof getTargetById>>, TError = AxiosError<MinimalTarget>>(
 targetId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargetById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTargetById>>,
          TError,
          Awaited<ReturnType<typeof getTargetById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTargetById<TData = Awaited<ReturnType<typeof getTargetById>>, TError = AxiosError<MinimalTarget>>(
 targetId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargetById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get target in JSON
 */

export function useGetTargetById<TData = Awaited<ReturnType<typeof getTargetById>>, TError = AxiosError<MinimalTarget>>(
 targetId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargetById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTargetByIdQueryOptions(targetId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetTargetByIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getTargetById>>, TError = AxiosError<MinimalTarget>>(targetId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargetById>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTargetByIdQueryKey(targetId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTargetById>>> = ({ signal }) => getTargetById(targetId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargetById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTargetByIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getTargetById>>>
export type GetTargetByIdSuspenseQueryError = AxiosError<MinimalTarget>


export function useGetTargetByIdSuspense<TData = Awaited<ReturnType<typeof getTargetById>>, TError = AxiosError<MinimalTarget>>(
 targetId: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargetById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTargetByIdSuspense<TData = Awaited<ReturnType<typeof getTargetById>>, TError = AxiosError<MinimalTarget>>(
 targetId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargetById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTargetByIdSuspense<TData = Awaited<ReturnType<typeof getTargetById>>, TError = AxiosError<MinimalTarget>>(
 targetId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargetById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get target in JSON
 */

export function useGetTargetByIdSuspense<TData = Awaited<ReturnType<typeof getTargetById>>, TError = AxiosError<MinimalTarget>>(
 targetId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargetById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTargetByIdSuspenseQueryOptions(targetId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Can be used for getting tracked target limit.
 * @summary Get tracked target limit in JSON
 */
export const getTrackedTargetLimit = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<number>> => {
    
    
    return axios.default.get(
      `/api/v1.1/targets/trackedTargetLimit`,options
    );
  }




export const getGetTrackedTargetLimitQueryKey = () => {
    return [
    `/api/v1.1/targets/trackedTargetLimit`
    ] as const;
    }

    
export const getGetTrackedTargetLimitQueryOptions = <TData = Awaited<ReturnType<typeof getTrackedTargetLimit>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackedTargetLimit>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTrackedTargetLimitQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrackedTargetLimit>>> = ({ signal }) => getTrackedTargetLimit({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTrackedTargetLimit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTrackedTargetLimitQueryResult = NonNullable<Awaited<ReturnType<typeof getTrackedTargetLimit>>>
export type GetTrackedTargetLimitQueryError = AxiosError<unknown>


export function useGetTrackedTargetLimit<TData = Awaited<ReturnType<typeof getTrackedTargetLimit>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackedTargetLimit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrackedTargetLimit>>,
          TError,
          Awaited<ReturnType<typeof getTrackedTargetLimit>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrackedTargetLimit<TData = Awaited<ReturnType<typeof getTrackedTargetLimit>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackedTargetLimit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrackedTargetLimit>>,
          TError,
          Awaited<ReturnType<typeof getTrackedTargetLimit>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrackedTargetLimit<TData = Awaited<ReturnType<typeof getTrackedTargetLimit>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackedTargetLimit>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get tracked target limit in JSON
 */

export function useGetTrackedTargetLimit<TData = Awaited<ReturnType<typeof getTrackedTargetLimit>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackedTargetLimit>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTrackedTargetLimitQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetTrackedTargetLimitSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getTrackedTargetLimit>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrackedTargetLimit>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTrackedTargetLimitQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrackedTargetLimit>>> = ({ signal }) => getTrackedTargetLimit({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrackedTargetLimit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTrackedTargetLimitSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getTrackedTargetLimit>>>
export type GetTrackedTargetLimitSuspenseQueryError = AxiosError<unknown>


export function useGetTrackedTargetLimitSuspense<TData = Awaited<ReturnType<typeof getTrackedTargetLimit>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrackedTargetLimit>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrackedTargetLimitSuspense<TData = Awaited<ReturnType<typeof getTrackedTargetLimit>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrackedTargetLimit>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrackedTargetLimitSuspense<TData = Awaited<ReturnType<typeof getTrackedTargetLimit>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrackedTargetLimit>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get tracked target limit in JSON
 */

export function useGetTrackedTargetLimitSuspense<TData = Awaited<ReturnType<typeof getTrackedTargetLimit>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrackedTargetLimit>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTrackedTargetLimitSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Can be used for getting target count.
 * @summary Get target count in JSON
 */
export const getTargetCount = (
    params?: GetTargetCountParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<number>> => {
    
    
    return axios.default.get(
      `/api/v1.1/targets/count`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetTargetCountQueryKey = (params?: GetTargetCountParams,) => {
    return [
    `/api/v1.1/targets/count`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetTargetCountQueryOptions = <TData = Awaited<ReturnType<typeof getTargetCount>>, TError = AxiosError<unknown>>(params?: GetTargetCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargetCount>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTargetCountQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTargetCount>>> = ({ signal }) => getTargetCount(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTargetCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTargetCountQueryResult = NonNullable<Awaited<ReturnType<typeof getTargetCount>>>
export type GetTargetCountQueryError = AxiosError<unknown>


export function useGetTargetCount<TData = Awaited<ReturnType<typeof getTargetCount>>, TError = AxiosError<unknown>>(
 params: undefined |  GetTargetCountParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargetCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTargetCount>>,
          TError,
          Awaited<ReturnType<typeof getTargetCount>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTargetCount<TData = Awaited<ReturnType<typeof getTargetCount>>, TError = AxiosError<unknown>>(
 params?: GetTargetCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargetCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTargetCount>>,
          TError,
          Awaited<ReturnType<typeof getTargetCount>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTargetCount<TData = Awaited<ReturnType<typeof getTargetCount>>, TError = AxiosError<unknown>>(
 params?: GetTargetCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargetCount>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get target count in JSON
 */

export function useGetTargetCount<TData = Awaited<ReturnType<typeof getTargetCount>>, TError = AxiosError<unknown>>(
 params?: GetTargetCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargetCount>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTargetCountQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetTargetCountSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getTargetCount>>, TError = AxiosError<unknown>>(params?: GetTargetCountParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargetCount>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTargetCountQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTargetCount>>> = ({ signal }) => getTargetCount(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargetCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTargetCountSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getTargetCount>>>
export type GetTargetCountSuspenseQueryError = AxiosError<unknown>


export function useGetTargetCountSuspense<TData = Awaited<ReturnType<typeof getTargetCount>>, TError = AxiosError<unknown>>(
 params: undefined |  GetTargetCountParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargetCount>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTargetCountSuspense<TData = Awaited<ReturnType<typeof getTargetCount>>, TError = AxiosError<unknown>>(
 params?: GetTargetCountParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargetCount>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTargetCountSuspense<TData = Awaited<ReturnType<typeof getTargetCount>>, TError = AxiosError<unknown>>(
 params?: GetTargetCountParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargetCount>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get target count in JSON
 */

export function useGetTargetCountSuspense<TData = Awaited<ReturnType<typeof getTargetCount>>, TError = AxiosError<unknown>>(
 params?: GetTargetCountParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargetCount>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTargetCountSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Gives back the maximum trackable number of vehicles
 * @summary Get all available targets in JSON
 */
export const getAllTrackableTargets = (
    params?: GetAllTrackableTargetsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TargetsResponse>> => {
    
    
    return axios.default.get(
      `/api/v1.1/targets/all/trackable`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetAllTrackableTargetsQueryKey = (params?: GetAllTrackableTargetsParams,) => {
    return [
    `/api/v1.1/targets/all/trackable`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAllTrackableTargetsQueryOptions = <TData = Awaited<ReturnType<typeof getAllTrackableTargets>>, TError = AxiosError<unknown>>(params?: GetAllTrackableTargetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllTrackableTargets>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllTrackableTargetsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllTrackableTargets>>> = ({ signal }) => getAllTrackableTargets(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllTrackableTargets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllTrackableTargetsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllTrackableTargets>>>
export type GetAllTrackableTargetsQueryError = AxiosError<unknown>


export function useGetAllTrackableTargets<TData = Awaited<ReturnType<typeof getAllTrackableTargets>>, TError = AxiosError<unknown>>(
 params: undefined |  GetAllTrackableTargetsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllTrackableTargets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllTrackableTargets>>,
          TError,
          Awaited<ReturnType<typeof getAllTrackableTargets>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllTrackableTargets<TData = Awaited<ReturnType<typeof getAllTrackableTargets>>, TError = AxiosError<unknown>>(
 params?: GetAllTrackableTargetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllTrackableTargets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllTrackableTargets>>,
          TError,
          Awaited<ReturnType<typeof getAllTrackableTargets>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllTrackableTargets<TData = Awaited<ReturnType<typeof getAllTrackableTargets>>, TError = AxiosError<unknown>>(
 params?: GetAllTrackableTargetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllTrackableTargets>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all available targets in JSON
 */

export function useGetAllTrackableTargets<TData = Awaited<ReturnType<typeof getAllTrackableTargets>>, TError = AxiosError<unknown>>(
 params?: GetAllTrackableTargetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllTrackableTargets>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllTrackableTargetsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAllTrackableTargetsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAllTrackableTargets>>, TError = AxiosError<unknown>>(params?: GetAllTrackableTargetsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllTrackableTargets>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllTrackableTargetsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllTrackableTargets>>> = ({ signal }) => getAllTrackableTargets(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllTrackableTargets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllTrackableTargetsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAllTrackableTargets>>>
export type GetAllTrackableTargetsSuspenseQueryError = AxiosError<unknown>


export function useGetAllTrackableTargetsSuspense<TData = Awaited<ReturnType<typeof getAllTrackableTargets>>, TError = AxiosError<unknown>>(
 params: undefined |  GetAllTrackableTargetsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllTrackableTargets>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllTrackableTargetsSuspense<TData = Awaited<ReturnType<typeof getAllTrackableTargets>>, TError = AxiosError<unknown>>(
 params?: GetAllTrackableTargetsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllTrackableTargets>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllTrackableTargetsSuspense<TData = Awaited<ReturnType<typeof getAllTrackableTargets>>, TError = AxiosError<unknown>>(
 params?: GetAllTrackableTargetsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllTrackableTargets>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all available targets in JSON
 */

export function useGetAllTrackableTargetsSuspense<TData = Awaited<ReturnType<typeof getAllTrackableTargets>>, TError = AxiosError<unknown>>(
 params?: GetAllTrackableTargetsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllTrackableTargets>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllTrackableTargetsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




